import { render, staticRenderFns } from "./AddStudentProfilePhoto.vue?vue&type=template&id=8bb09b56&scoped=true&"
import script from "./AddStudentProfilePhoto.vue?vue&type=script&lang=js&"
export * from "./AddStudentProfilePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb09b56",
  null
  
)

export default component.exports